import React from 'react';
import GenericTabs from '../../../../../ui-components/Tabs/GenericTabs';

export type BgpViewMode = 'topology' | 'table';

interface ViewModeTabsProps {
  viewMode: BgpViewMode;
  onViewModeChange: (mode: BgpViewMode) => void;
}

/**
 * Topology ⇄ Table switch, previously hand-rolled markup inside `BgpVisibilityPage`.
 *
 * Uses `GenericTabs` rather than `ui-components/SegmentedContol` even though the latter is
 * nominally the segmented-control primitive: that one is built on hardcoded palette classes
 * (`bg-gray-100`, `bg-white text-black`, `text-gray-500`) and would render wrong in the dark
 * theme. `GenericTabs` is token-based, and reusing it keeps this pill visually identical to the
 * direction tabs beside it.
 */
export const ViewModeTabs: React.FC<ViewModeTabsProps> = ({ viewMode, onViewModeChange }) => {
  return (
    <div className="w-max flex-shrink-0">
      <GenericTabs
        tabs={[
          { label: 'Topology', value: 'topology' },
          { label: 'Table', value: 'table' }
        ]}
        activeTab={viewMode}
        onTabChange={(value: string) => onViewModeChange(value as BgpViewMode)}
        size="xs"
        fullWidth={false}
        fitContent
        aria-label="View mode"
      />
    </div>
  );
};
